import React, { useState } from "react";
import styled from 'styled-components';
import { Button } from '@process-advisor/process-miner/components/shared/button';
import { getColor} from '@process-advisor/process-miner/shared/theme';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { DataGrid } from '@process-advisor/process-miner/discoveryRules/discoveryRulesDataGrid';
import { Event } from '@process-advisor/process-miner/api/events';
import Axios from 'axios';
import { useApiListener } from '@process-advisor/process-miner/shared/hooks/useApiListener';
import { openProgressModal } from '@process-advisor/process-miner/api/methods/modals/openProgressModal';
import { closeProgressModal } from '@process-advisor/process-miner/api/methods/modals/closeProgressModal';
import { updateDiscoveryRule, saveDiscoveryChildDiscoveryRules, loadDiscoveryRulesForCurrentModel } from '@process-advisor/process-miner/processMiner/processMiner';

export type Row = {};

const noopModule = {
  invoke: () => Promise.resolve({ active: true, type: 'COMMERCIAL', items: [], result: [], customer_id: '' }),
  requestJira: () => Promise.resolve({
    json: () => Promise.resolve({ groups: { items: [] }, accountId: '', values: [], siteUrl: '' })
  }),
  view: { getContext: () => Promise.resolve({ siteUrl: '', localId: '' }) },
  router: { navigate: () => Promise.resolve() },
};
let forgeModule = null;
const loadForgeModule = async () => {
  if (!forgeModule) {
    try {
      const mod = await import('@forge/bridge');
      forgeModule = (typeof mod.invoke === 'function') ? mod : noopModule;
    } catch(e) {
      forgeModule = noopModule;
    }
  }
  return forgeModule;
};

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: ${getColor('white')};
    padding: 10px;
`;

const GridWrapper = styled.div`
    flex: 1;
    min-height: 0;
    width: 100%;
`;

const ButtonBar = styled.div`
    display: flex;
    gap: 10px;
    padding: 20px 0;
    justify-content: center;
    align-items: center;
`;

type DiscoveryRulesProps  = {
    customer_id?: string,
    mode?: string,
    AppVersion?: string,
    AI?: string,
}

export const DiscoveryRules: React.FC<DiscoveryRulesProps> = ({customer_id,mode,AppVersion,AI}) => {

    const [data, setData] = React.useState([]);
    const [rows, setRows] = React.useState([])
    const [discoveryRuleData, setDiscoveryRuleData] = useState();
    const [refreshDiscoveryRules, setRefreshDiscoveryRules] = React.useState(false)
  
    React.useEffect(() => {
        setData(apiProvider.processDiscoveryRulesSummary());
    }, []);

    React.useEffect(() => {
        setData(apiProvider.processDiscoveryRulesSummary());
        setRefreshDiscoveryRules(false)
    }, [refreshDiscoveryRules]);

    useApiListener(Event.setActionBar_DiscoveryRulesVisualizer, () => {
        setData(apiProvider.processDiscoveryRulesSummary());
    });


    React.useEffect(() => {
        if (data.length > 0 ) {
            let tempRows = data.map((row, id) => ({ id, ...row }));
            setRows(tempRows)
        } else {
            setRows([])
        }
    }, [data]);

    const loadAutomatedDiscoveryRules = async () => {
        openProgressModal({status: 'Loading Discovery Rules'})
        await sleep(200) // needed to display Progress
        await loadDiscoveryRulesForCurrentModel()
        await apiProvider.resetFilters({})
        setData(apiProvider.processDiscoveryRulesSummary())
        closeProgressModal()
    }

    const deleteDiscoveryRules = async () => {
       
        openProgressModal({status: 'Deleting discoveryRules'})
        await sleep(200) // needed to display Progress
        for (let k = 0; k < rows.length; k++) {
            await apiProvider.deleteDiscoveryRule(({ discovery_rule_id: rows[k].discovery_rule_id }))
        }
        apiProvider.setSaveModel({saveModel:true})
        setData(apiProvider.processDiscoveryRulesSummary());
        closeProgressModal()
    }

    const sleep = ms => new Promise(r => setTimeout(r, ms));
    const saveDiscoveryRules = async (type) => {

        let issueType = apiProvider.getIssueTypes()
        let activityType = apiProvider.getActivityType().toLowerCase()

        let discoveryRules
        if (false) {
            const BASE_URL = `https://process-optimizer-jira.metricus.com/api/discoveryRule/retrieve_all`;
            const API = Axios.create({ baseURL: BASE_URL });
            let res = await API.get(customer_id);
            discoveryRules = res.data.data.discovery_ruleData
        }
        if (AppVersion === 'FORGE') {
            try {
                const { invoke } = await loadForgeModule();
                discoveryRules = await invoke('getDiscoveryRules');
            } catch (err) {
                console.log(`Error: ${err.message}`)
                discoveryRules = [];
            } 
        }

        if (!discoveryRules || discoveryRules.length === 0) {
            console.log('No discoveryRules data available');
            return;
        }

        for (let k = 0; k < discoveryRules.length; k++) {
            let automation_opportunity = false
            let calculate_cost_impact = false
            let save_variants = false
            let save_activities = false
            let save_steps = false

            if (discoveryRules[k].automation_opportunity === 1) automation_opportunity = true
            if (discoveryRules[k].calculate_cost_impact === 1) calculate_cost_impact = true
            if (discoveryRules[k].save_variants === 1) save_variants = true
            if (discoveryRules[k].save_activities === 1) save_activities = true
            if (discoveryRules[k].save_steps === 1) save_steps = true

            let discoveryRuleOK = false
            if (type === 'issueType') if (discoveryRules[k].issue_type === issueType) discoveryRuleOK = true
            if (type === 'generic') if (discoveryRules[k].issue_type === 'Generic' ) discoveryRuleOK = true
            if (discoveryRuleOK && activityType === discoveryRules[k].activity_type) {
                openProgressModal({status: 'Loading Discovery Rule: \r\n' + discoveryRules[k].discovery_rule})
                await updateDiscoveryRule({
                    discovery_rule: discoveryRules[k].discovery_rule,
                    id: discoveryRules[k].id,
                    mode: 'new',
                    category: discoveryRules[k].category,
                    automation_opportunity: automation_opportunity,
                    calculate_cost_impact: calculate_cost_impact,
                    process: true,
                    discovery_rule_detail: [],
                    filters: JSON.parse(discoveryRules[k].filters),
                    save_variants: save_variants,
                    save_activities: save_activities,
                    save_steps: save_steps,
                    type: discoveryRules[k].type,
                    discovery_rule_type: discoveryRules[k].discovery_rule_type
                },'','loadDiscoveryRulesGeneric')
                if (discoveryRules[k].discovery_rule_type === 'parent_discovery') {
                    await saveDiscoveryChildDiscoveryRules()
                }
                await apiProvider.resetFilters({})
            }
        }   
    }
    
    React.useEffect(() => {
        const listener = () =>
            setData(apiProvider.processDiscoveryRulesSummary());
        listener();

        apiProvider.on(Event.updateDiscoveryRules, listener);
        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.updateDiscoveryRules, listener);
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    return (
        <Wrapper>
            <GridWrapper>
                <DataGrid
                    rows={rows}
                    customer_id={customer_id}
                    refreshDiscoveryRules={setRefreshDiscoveryRules}
                    AppVersion={AppVersion}
                />
            </GridWrapper>
            <ButtonBar>
                <Button label='Load Discovery Rules' onClick={loadAutomatedDiscoveryRules} />
                <Button label='Delete Discovery Rules' onClick={deleteDiscoveryRules} />
            </ButtonBar>
        </Wrapper>
    );
};



